import { newRequestMercurio } from "std/api/mercurio/newRequestMercurio";
import { useLoginStore } from "../store";

export async function apiLoginLogof(): Promise<unknown> {
	const response = await newRequestMercurio({
		url: "Login/Logof",
		type: "post",
	});

	useLoginStore.getState().clearLogin();

	return response;
}
